import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import { Breadcrumbs, Typography, Link as MuiLink, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddTitleToBroswerTab from "../molecules/AddTitleToBroswerTab";

const useStyles = makeStyles((theme: Theme) => ({
  breadcrumbs: {
    fontSize: 12,
    color: "#000",
  },
}));
interface Props {
  heading?: string;
  module?: string;
  linkTo?: string;
  pageTitle?: string;
}

export default function TabHeader({
  heading = "Enter a heading",
  module = "Enter Module Name...",
  linkTo,
  pageTitle,
}: Props): ReactElement {
  const classes = useStyles();
  return (
    <>
      {pageTitle && <AddTitleToBroswerTab title={pageTitle} />}
      <Breadcrumbs
        className={classes.breadcrumbs}
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="inherit" />}
      >
        <MuiLink
          color="inherit"
          component={Link}
          to={`/${linkTo || module}`}
          className={classes.breadcrumbs}
        >
          {module}
        </MuiLink>
        <Typography className={classes.breadcrumbs}>{heading}</Typography>
      </Breadcrumbs>
    </>
  );
}
